export default __webpack_public_path__ + "static/media/logo.a90e6373.svg";